import React, { useEffect, useState } from 'react';
import {
   Input,
   VStack,
   Text,
   Button,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalBody,
   ModalCloseButton,
   InputGroup,
   InputLeftElement,
   Textarea,
   useDisclosure,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   Badge,
   useColorMode,
   FormControl,
   FormLabel,
   Grid,
   Checkbox,
   GridItem,
   Box,
   Flex,
   HStack,
   Icon,
   Divider,
} from '@chakra-ui/react';
import { Search, Filter, Calendar, FileText, AlertCircle, Check, X } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from 'contexts';
import AddEditForm from '../../masters/Pages/AllAccountMaster/AddEditFormForAccount';
import SingleSelectDropdown from 'components/ui/SingleSelectDropdown';
import { useAccount } from '../../../../contexts';
import { getStoreSales, partyServiceBlock } from '../../../../redux/actions/salesInvoice';

export default function WarrantyForm({ isAccountModal, onClose }) {
   const { user } = useUser();
   const { accounts: accountData } = useAccount();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const isColorMode = !isDark;
   const dispatch = useDispatch();
   const [data, setData] = useState([]);
   const [accountId, setAccountId] = useState(null);
   const [searchQuery, setSearchQuery] = useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = React.useState('');
   const [notes, setNotes] = useState("");
   const [selectedRows, setSelectedRows] = useState([]);
   const companyList = useSelector((state) => state.company.list);
   const company = companyList.find((comp) => comp.id === user?.loginhistory?.companyId);

   const [entryType, setEntryType] = useState("SALES");
   const [filterType, setFilterType] = useState("notBlock");

   const filteredData = data.filter((entry) => {

      if (filterType === "block") return entry.isBlocked === true;
      if (filterType === "notBlock") return entry.isBlocked === false;

      return false;
   });

   const handleRowSelect = (entryId) => {
      setSelectedRows((prev) => {
         if (prev.includes(entryId)) {
            return prev.filter((id) => id !== entryId);
         } else {
            return [...prev, entryId];
         }
      });
   };

   const handleSelectAll = () => {
      if (selectedRows.length === filteredData.length) {
         setSelectedRows([]);
      } else {
         setSelectedRows(filteredData.map((entry) => entry.id));
      }
   };

   const handleSave = async () => {
      const selectedData = data.filter((entry) => selectedRows.includes(entry.id));
      const playload = {
         accountId: accountId,
         salesIds: selectedRows,
         isBlocked: filterType === "block" ? false : true,
         type: entryType,
         reason: notes,
      };
      const res = await dispatch(partyServiceBlock(playload));
      if (res && res?.code === 1) {
         setSelectedRows([]);
         setFilterType("notBlock");
         setNotes('');
         setSearchQuery('');
         setDebouncedSearchQuery('');
         const getres = await dispatch(getStoreSales({ accountId: accountId, companyId: user?.loginhistory?.companyId, type: entryType }));
         if (getres && getres?.data && getres?.data.length > 0) {
            setData(getres?.data);
         }
      }
   };

   const handleFetchData = async (selectaccountId, search, value) => {
      const playload = {
         accountId: selectaccountId || accountId,
         companyId: user?.loginhistory?.companyId,
         type: value,
         search: search
      };
      console.log("playload", playload, accountId);
      const res = await dispatch(getStoreSales(playload));
      if (res && res?.data) {
         setData(res?.data);
      }
   };

   const handleClose = () => {
      setData([]);
      setAccountId(null);
      setSelectedRows([]);
      setFilterType("notBlock");
      setNotes('');
      setEntryType("SALES");
      onClose();
   };

   const handleAccountChange = (Values) => {
      setAccountId(Values);
      setSelectedRows([]);
      setFilterType("notBlock");
      setEntryType("SALES");
      setDebouncedSearchQuery('');
      setSearchQuery('');
      if (Values) {
         handleFetchData(Values, '', entryType);
      }
   };

   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };

   const debouncedSearchHandler = React.useCallback(
      debounce((accountId, query) => {
         handleFetchData(accountId, query, entryType);
      }, 500),
      [],
   );

   const handleSearchChange = (accountId, value) => {
      setSearchQuery(value);
      debouncedSearchHandler(accountId, value);
      setSelectedRows([]);
   };

   const handleChangeType = (value) => {
      setEntryType(value);
      setFilterType("notBlock");
      setDebouncedSearchQuery('');
      setSearchQuery('');
      setSelectedRows([]);
      if (value && accountId) {
         handleFetchData(accountId, '', value);
      }
   };

   return (
      <>
         <Modal isOpen={isAccountModal} onClose={handleClose} size="6xl">
            <ModalOverlay bg="blackAlpha.700" backdropFilter="blur(10px)" />
            <ModalContent
               maxW="90vw"
               bg={isDark ? 'gray.900' : 'white'}
               borderRadius="3xl"
               boxShadow="2xl"
               overflow="hidden">

               {/* Modern Header with Gradient */}
               <Box
                  bgGradient={isDark
                     ? 'linear(to-r, purple.600, blue.500)'
                     : 'linear(to-r, purple.400, blue.400)'}
                  p={6}>
                  <HStack spacing={4} align="center">
                     <Box
                        bg={isDark ? 'whiteAlpha.200' : 'whiteAlpha.300'}
                        p={3}
                        borderRadius="xl"
                        backdropFilter="blur(10px)">
                        <Search size={28} color="white" />
                     </Box>
                     <VStack align="start" spacing={0}>
                        <Text fontSize="2xl" fontWeight="bold" color="white">
                           Entry Management System
                        </Text>
                        <Text fontSize="sm" color="whiteAlpha.900">
                           Search, filter, and manage account entries
                        </Text>
                     </VStack>
                  </HStack>
                  <ModalCloseButton color="white" size="lg" top={4} right={4} />
               </Box>

               <ModalBody p={6}>
                  <VStack spacing={6} align="stretch">

                     {/* Account Selection Card */}
                     <Box
                        bg={isDark ? 'gray.800' : 'gray.50'}
                        borderRadius="2xl"
                        p={6}
                        border="2px solid"
                        borderColor={isDark ? 'gray.700' : 'gray.200'}
                        transition="all 0.3s"
                        _hover={{
                           borderColor: isDark ? 'purple.500' : 'purple.400',
                           shadow: 'xl'
                        }}>
                        <HStack spacing={4} align="end">
                           <Box flex={1}>
                              <SingleSelectDropdown
                                 label="Account"
                                 options={accountData}
                                 value={accountId}
                                 onChange={handleAccountChange}
                                 placeholder="Select Account"
                                 isRequired={true}
                                 error={''}
                                 showAddButton={true}
                                 onAddNew={(value) => console.log('handleAddNew', value)}
                                 isLoading={false}
                                 darkMode={!isColorMode}
                                 AddEditFormComponent={AddEditForm}
                              />
                           </Box>
                           {accountId && (
                              <Box flex={1}>
                                 <FormLabel color={isDark ? 'gray.300' : 'gray.700'} fontWeight="semibold" mb={2}>
                                    Search Entries
                                 </FormLabel>
                                 <InputGroup size="lg">
                                    <InputLeftElement>
                                       <Search size={20} color={isDark ? '#A0AEC0' : '#718096'} />
                                    </InputLeftElement>
                                    <Input
                                       placeholder="Search by doc no, item, serial..."
                                       value={searchQuery}
                                       onChange={(e) => handleSearchChange(accountId, e.target.value)}
                                       bg={isDark ? 'gray.700' : 'white'}
                                       border="2px solid"
                                       borderColor={isDark ? 'gray.600' : 'gray.300'}
                                       borderRadius="xl"
                                       _hover={{
                                          borderColor: isDark ? 'purple.400' : 'purple.500'
                                       }}
                                       _focus={{
                                          borderColor: 'purple.500',
                                          boxShadow: `0 0 0 3px ${isDark ? 'rgba(159, 122, 234, 0.2)' : 'rgba(159, 122, 234, 0.3)'}`
                                       }}
                                    />
                                 </InputGroup>
                              </Box>
                           )}
                        </HStack>
                        {accountId && (
                           <HStack spacing={4} align="end">
                              <Grid templateColumns="repeat(2, 1fr)" gap={4} width="100%" mt={2}>
                                 <FormControl>
                                    <FormLabel color={isDark ? 'gray.300' : 'gray.700'} fontWeight="semibold">
                                       Entry Type
                                    </FormLabel>
                                    <Box
                                       as="select"
                                       value={entryType}
                                       onChange={(e) => {
                                          handleChangeType(e.target.value);
                                       }}
                                       bg={isDark ? 'gray.700' : 'white'}
                                       border="2px solid"
                                       borderColor={isDark ? 'gray.600' : 'gray.300'}
                                       borderRadius="xl"
                                       width="100%"
                                       p={3}
                                       fontSize="md"
                                       fontWeight="medium"
                                       cursor="pointer"
                                       transition="all 0.2s"
                                       _hover={{
                                          borderColor: isDark ? 'purple.400' : 'purple.500'
                                       }}>
                                       <option value="SALES">Sales</option>
                                       <option value="PURCHASE_RETURN">Purchse Return</option>
                                    </Box>
                                 </FormControl>
                                 <FormControl>
                                    <FormLabel color={isDark ? 'gray.300' : 'gray.700'} fontWeight="semibold">
                                       Entry Status Type
                                    </FormLabel>
                                    <Box
                                       as="select"
                                       value={filterType}
                                       onChange={(e) => {
                                          setFilterType(e.target.value);
                                          setSelectedRows([]);
                                       }}
                                       bg={isDark ? 'gray.700' : 'white'}
                                       border="2px solid"
                                       borderColor={isDark ? 'gray.600' : 'gray.300'}
                                       borderRadius="xl"
                                       width="100%"
                                       p={3}
                                       fontSize="md"
                                       fontWeight="medium"
                                       cursor="pointer"
                                       transition="all 0.2s"
                                       _hover={{
                                          borderColor: isDark ? 'purple.400' : 'purple.500'
                                       }}>
                                       <option value="notBlock">Normal Entries</option>
                                       <option value="block">Blocked Entries</option>
                                    </Box>
                                 </FormControl>
                              </Grid>
                           </HStack>
                        )}
                     </Box>

                     {/* Data Table */}
                     {filteredData.length > 0 && accountId !== null ? (
                        <Box
                           bg={isDark ? 'gray.800' : 'white'}
                           borderRadius="2xl"
                           overflow="hidden"
                           border="2px solid"
                           borderColor={isDark ? 'gray.700' : 'gray.200'}
                           boxShadow="xl">
                           <Box maxH="500px" overflowY="auto" className="custom-scrollbar">
                              <Table variant="simple" size="md">
                                 <Thead
                                    position="sticky"
                                    top={0}
                                    bg={isDark ? 'gray.900' : 'gray.100'}
                                    zIndex={10}
                                    borderBottom="3px solid"
                                    borderColor={isDark ? 'purple.600' : 'purple.400'}>
                                    <Tr>
                                       <Th py={4} color={isDark ? 'purple.300' : 'purple.700'} fontSize="sm">
                                          <HStack spacing={2}>
                                             <Checkbox
                                                isChecked={selectedRows.length === filteredData.length && filteredData.length > 0}
                                                isIndeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                                                onChange={handleSelectAll}
                                                colorScheme="purple"
                                                size="lg"
                                             />
                                             <Badge
                                                colorScheme="purple"
                                                fontSize="xs"
                                                borderRadius="full"
                                                px={3}
                                                py={1}>
                                                {selectedRows.length}/{filteredData.length}
                                             </Badge>
                                          </HStack>
                                       </Th>
                                       <Th py={4} color={isDark ? 'purple.300' : 'purple.700'} fontSize="sm">Doc No</Th>
                                       <Th py={4} color={isDark ? 'purple.300' : 'purple.700'} fontSize="sm">Date</Th>
                                       <Th py={4} color={isDark ? 'purple.300' : 'purple.700'} fontSize="sm">Item Name</Th>
                                       <Th py={4} color={isDark ? 'purple.300' : 'purple.700'} fontSize="sm">Serial Number</Th>
                                       {filterType === "block" && (
                                          <>
                                             <Th py={4} color={isDark ? 'purple.300' : 'purple.700'} fontSize="sm">Reason</Th>
                                             <Th py={4} color={isDark ? 'purple.300' : 'purple.700'} fontSize="sm">Blocked Date</Th>
                                             <Th py={4} color={isDark ? 'purple.300' : 'purple.700'} fontSize="sm">Blocked By</Th>
                                          </>
                                       )}
                                       <Th py={4} color={isDark ? 'purple.300' : 'purple.700'} fontSize="sm">Type</Th>
                                       <Th py={4} color={isDark ? 'purple.300' : 'purple.700'} fontSize="sm">Status</Th>
                                    </Tr>
                                 </Thead>
                                 <Tbody>
                                    {filteredData.map((entry) => (
                                       <Tr
                                          key={entry.id}
                                          bg={selectedRows.includes(entry.id)
                                             ? isDark ? 'purple.900' : 'purple.50'
                                             : 'transparent'}
                                          _hover={{
                                             bg: isDark ? 'gray.700' : 'gray.50',
                                             transform: 'scale(1.005)',
                                             transition: 'all 0.2s'
                                          }}
                                          cursor="pointer"
                                          transition="all 0.2s">
                                          <Td py={4}>
                                             <Checkbox
                                                isChecked={selectedRows.includes(entry.id)}
                                                onChange={() => handleRowSelect(entry.id)}
                                                colorScheme="purple"
                                                size="lg"
                                                onClick={(e) => e.stopPropagation()}
                                             />
                                          </Td>
                                          <Td py={4} fontWeight="semibold" color={isDark ? 'gray.200' : 'gray.800'}>
                                             {entry.docno}
                                          </Td>
                                          <Td py={4} color={isDark ? 'gray.300' : 'gray.600'}>
                                             {new Date(entry.createdAt).toLocaleDateString('en-GB')}
                                          </Td>
                                          <Td py={4} fontWeight="medium" color={isDark ? 'gray.200' : 'gray.800'}>
                                             {entry.itemName}
                                          </Td>
                                          <Td py={4}>
                                             <Badge
                                                colorScheme="purple"
                                                fontSize="sm"
                                                borderRadius="lg"
                                                px={3}
                                                py={1.5}
                                                fontWeight="bold">
                                                {entry.serialNo}
                                             </Badge>
                                          </Td>
                                          {filterType === "block" && (
                                             <>
                                                <Td py={4} color={isDark ? 'gray.300' : 'gray.600'} fontSize="sm">
                                                   {entry.reason}
                                                </Td>
                                                <Td py={4} color={isDark ? 'gray.300' : 'gray.600'}>
                                                   {new Date(entry.blockedAt).toLocaleDateString('en-GB')}
                                                </Td>
                                                <Td py={4} color={isDark ? 'gray.300' : 'gray.600'}>
                                                   {entry.blockedByName}
                                                </Td>
                                             </>
                                          )}
                                          <Td py={4}>
                                             <Badge
                                                colorScheme={"yellow"}
                                                fontSize="sm"
                                                borderRadius="full"
                                                px={4}
                                                py={1.5}
                                                display="flex"
                                                alignItems="center"
                                                gap={1}
                                                w="fit-content">
                                                {entry.type === "purchaseReturn" ? "Purchase Return" : entry.type}
                                             </Badge>
                                          </Td>
                                          <Td py={4}>
                                             <Badge
                                                colorScheme={entry.isBlocked ? "red" : "green"}
                                                fontSize="sm"
                                                borderRadius="full"
                                                px={4}
                                                py={1.5}
                                                display="flex"
                                                alignItems="center"
                                                gap={1}
                                                w="fit-content">
                                                {entry.isBlocked ? <X size={14} /> : <Check size={14} />}
                                                {entry.isBlocked ? "Blocked" : "Active"}
                                             </Badge>
                                          </Td>
                                       </Tr>
                                    ))}
                                 </Tbody>
                              </Table>
                           </Box>
                        </Box>
                     ) : (
                        <Box
                           bg={isDark ? 'gray.800' : 'gray.50'}
                           borderRadius="2xl"
                           p={16}
                           textAlign="center"
                           border="2px dashed"
                           borderColor={isDark ? 'gray.700' : 'gray.300'}>
                           <VStack spacing={4}>
                              <Box
                                 bg={isDark ? 'gray.700' : 'white'}
                                 p={6}
                                 borderRadius="2xl"
                                 boxShadow="lg">
                                 <AlertCircle size={48} color={isDark ? '#A0AEC0' : '#718096'} />
                              </Box>
                              <Text fontSize="xl" fontWeight="bold" color={isDark ? 'gray.400' : 'gray.600'}>
                                 {accountId ? 'No entries found' : 'Select an account to begin'}
                              </Text>
                              <Text fontSize="sm" color={isDark ? 'gray.500' : 'gray.500'}>
                                 {accountId ? 'Try adjusting your search or filter criteria' : 'Choose an account from the dropdown above'}
                              </Text>
                           </VStack>
                        </Box>
                     )}

                     {/* Filter Controls - Only show when data exists */}
                     {data.length > 0 && accountId && selectedRows.length > 0 && filterType !== "block" && (
                        <Box
                           bg={isDark ? 'gray.800' : 'gray.50'}
                           borderRadius="2xl"
                           p={6}
                           border="2px solid"
                           borderColor={isDark ? 'gray.700' : 'gray.200'}>
                           <Grid templateColumns="repeat(1, 1fr)" gap={4}>
                              <FormControl mt={0}>
                                 <FormLabel color={isDark ? 'gray.300' : 'gray.700'} fontWeight="semibold">
                                    <HStack spacing={2}>
                                       <FileText size={16} />
                                       <Text>Reason for Blocking (Optional)</Text>
                                    </HStack>
                                 </FormLabel>
                                 <Textarea
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                    placeholder="Enter reason for blocking selected entries..."
                                    bg={isDark ? 'gray.700' : 'white'}
                                    border="2px solid"
                                    borderColor={isDark ? 'gray.600' : 'gray.300'}
                                    borderRadius="xl"
                                    size="lg"
                                    rows={3}
                                    _hover={{
                                       borderColor: isDark ? 'purple.400' : 'purple.500'
                                    }}
                                    _focus={{
                                       borderColor: 'purple.500',
                                       boxShadow: `0 0 0 3px ${isDark ? 'rgba(159, 122, 234, 0.2)' : 'rgba(159, 122, 234, 0.3)'}`
                                    }}
                                 />
                              </FormControl>
                           </Grid>
                        </Box>
                     )}

                     {/* Action Bar - Fixed at bottom when items selected */}
                     {data.length > 0 && selectedRows.length > 0 && (
                        <Box
                           position="sticky"
                           bottom={0}
                           bg={isDark ? 'blue.900' : 'blue.50'}
                           borderRadius="2xl"
                           p={5}
                           border="2px solid"
                           borderColor={isDark ? 'blue.700' : 'blue.300'}
                           boxShadow="2xl">
                           <Flex justify="space-between" align="center">
                              <HStack spacing={3}>
                                 <Badge
                                    colorScheme="blue"
                                    fontSize="lg"
                                    borderRadius="xl"
                                    px={4}
                                    py={2}
                                    fontWeight="bold">
                                    {selectedRows.length} item{selectedRows.length !== 1 ? 's' : ''} selected
                                 </Badge>
                                 <Text fontSize="md" color={isDark ? 'blue.200' : 'blue.700'} fontWeight="medium">
                                    Ready to {filterType === "block" ? "unblock" : "block"}
                                 </Text>
                              </HStack>
                              <HStack spacing={3}>
                                 <Button
                                    size="lg"
                                    variant="ghost"
                                    onClick={() => setSelectedRows([])}
                                    colorScheme="red"
                                    borderRadius="xl"
                                    fontWeight="bold">
                                    Cancel
                                 </Button>
                                 <Button
                                    size="lg"
                                    onClick={handleSave}
                                    bgGradient={isDark
                                       ? 'linear(to-r, green.600, teal.500)'
                                       : 'linear(to-r, green.400, teal.400)'}
                                    color="white"
                                    borderRadius="xl"
                                    fontWeight="bold"
                                    px={8}
                                    _hover={{
                                       bgGradient: isDark
                                          ? 'linear(to-r, green.500, teal.400)'
                                          : 'linear(to-r, green.500, teal.500)',
                                       transform: 'translateY(-2px)',
                                       boxShadow: 'xl'
                                    }}
                                    leftIcon={<Check size={20} />}>
                                    Save Changes
                                 </Button>
                              </HStack>
                           </Flex>
                        </Box>
                     )}
                  </VStack>
               </ModalBody>
            </ModalContent>
         </Modal>

         <style jsx global>{`
            .custom-scrollbar::-webkit-scrollbar {
               width: 8px;
            }
            .custom-scrollbar::-webkit-scrollbar-track {
               background: ${isDark ? '#2D3748' : '#F7FAFC'};
               border-radius: 10px;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb {
               background: ${isDark ? '#805AD5' : '#9F7AEA'};
               border-radius: 10px;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb:hover {
               background: ${isDark ? '#6B46C1' : '#805AD5'};
            }
         `}</style>
      </>
   );
}